import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { Collapse } from "react-bootstrap";
import "../YearlyCommonDashboard/YearlyCommonDashboard.css";
import { LoaderContext, getContext } from "../../../../Helpers/Context/Context";
import { APICall } from "../../../../Helpers/Network/APICalls";
import {
  CommonDropdownData,
  GetNewMemberDetailsYearWiseDashboard,
  GetFinancialYearDropdown,
  InsertYearlyWarrentReport,
} from "../../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../../Helpers/Enums/ApiStatus";
import notify, { ToastType } from "../../../../Helpers/ToastNotification";
import SelectForm from "../../../../Components/SelectForm/SelectForm";
import DynamicGrid from "../../../../Components/DynamicGrid/DynamicGrid";
import MultiSelect from "../../../../Components/SelectForm/MultiSelect";
import { RoleEnum } from "../../../../Helpers/Enums/RoleEnum";

Modal.setAppElement("#root"); // Use the selector for your root element

const YearlyCommonDashboard = (props) => {
  const { PageName, UploadExcel, ExportToExcelUrl, ExcelImport, openModal } =
    props;

  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitcode, setUnitCode] = useState([]);
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [financialYear, setFinancialYear] = useState(null);
  const [financialYearId, setFinancialYearId] = useState(null);
  const [dashboardData, setDashboardData] = useState([]);
  const [OpenUniCodeModal, setOpenUniCodeModal] = useState(false);
  const [fyear, SetFyear] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const isAdmin = context?.CurrentRoleId === RoleEnum.Admin;
  const isInternalTeam = context?.CurrentRoleId === RoleEnum.InternalTeam;
  let formErrorObj = {};

  const selectOnChange = (event: any, apiFieldName: any) => {
    debugger
    if (apiFieldName === "FinancialYear") {
      setFinancialYear(event);
      setFinancialYearId(event.value);
    }
    if (apiFieldName === "UnitCode") {
      setUnitCode(event);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        unitcode_isEmpty: "",
      }));
    }
  };
  useEffect(() => {
    getDropDownDataApiCall();
    generateFinancialYearOptions();
  }, []);

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const generateFinancialYearOptions = async () => {
    const result = await APICall(GetFinancialYearDropdown, {});
    const yearOptions = result.Data.map((item) => ({
      label: item.FinancialYear,
      value: item.Id,
    }));
    if (result?.Data?.length > 0) {
      setFinancialYearOptions(yearOptions);
    }
  };

  const getDropDownDataApiCall = async () => {
    let requestParams;
    if (isAdmin) {
      requestParams = {
        dropdownName: "unitcodedd",
      };
    } else if (isInternalTeam) {
      requestParams = {
        dropdownName: "unitcodeInternalTeam",
        UserRoleId: context.Id,
      };
    }

    // let requestParams = {
    //   dropdownName: "unitcodedd",
    // };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;
      await setUnitCodeOptions(options);
    } else {
      await setUnitCodeOptions([]);
    }
  };

  const exportToExcelFunction = async () => {
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });
    if (isEmpty === true) {
      const params = {
        DashboardType: PageName,
        MemberID: context.MemberId,
        RoleID: context.CurrentRoleId,
        FinancialYearID: fyear,
        UnitCodes:
          unitcode && unitcode.length > 0
            ? unitcode.map(({ value }) => value).toString()
            : "",
        CreatedBy: context.MemberId,
        ModifiedBy: context.MemberId,
      };

      const resp = await APICall(ExportToExcelUrl, params);
      if (resp?.Status == ApiStatus.OK) {
        notify(ToastType.Success, resp?.Message);
      } else {
        notify(ToastType.Error, resp?.Message);
      }
      closeUniCodeModal();
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (
      !unitcode ||
      Object.keys(unitcode).length <= 0 ||
      unitcode.length <= 0
    ) {
      formErrorObj["unitcode_isEmpty"] = "Unit code can not be empty";
    }
    setFormErrors(formErrorObj);
  };

  const getDashboardData = async (btn) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      FYId: financialYearId ? financialYearId : 0,
      UnitCodeId:
        unitcode && unitcode.length > 0
          ? unitcode.map(({ value }) => value).toString()
          : "",
      DashboardType: PageName,
    };

    if (btn === "reset") {
      obj = {
        start: 0,
        resultsPerPage: 10,
        searchText: "",
        sortColumn: "",
        sortDirection: "",
        FYId: 0,
        UnitCodeId: "",
        DashboardType: PageName,
      };
    }
    const resp = await APICall(GetNewMemberDetailsYearWiseDashboard, obj);

    if (resp?.Data?.length > 0) {
      setDashboardData(resp?.Data);
    } else {
      setDashboardData([]);
    }
    setCount(resp?.Data?.[0]?.TotalCount || resp?.Data?.length || 0);
    hideLoader();
  };

  const resetFunction = async () => {
    setFinancialYear(null);
    setFinancialYearId(null);
    setUnitCode([]);
    setSearchText("");
    setSortColumn("");
    setSortDirection("");
    setStart(0);
    setPageSize(10);
    setCount(0);
    setDashboardFilterOn(false);
    await getDashboardData("reset");
  };

  const onClickFunction = async (event, action) => {
    debugger
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          FinancialYear: financialYearId ? financialYearId : 0,
          // UnitCode:
          //   unitcode && unitcode.length > 0
          //     ? unitcode.map(({ value }) => value).toString()
          //     : "",
        };

        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (isEmptyReqObj === true) {
        notify(1, "Select at least one filter.");
      } else {
        await getDashboardData("");
      }
    }
  };

  const openUnitCodeModal = (fYear: any) => {
    SetFyear(fYear);
    setUnitCode(null);
    setOpenUniCodeModal(true);
  };

  const closeUniCodeModal = () => {
    setOpenUniCodeModal(false);
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "FinancialYear",
      label: "Financial Year",
      options: {
        display: true,
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: { width: "400px" },
        }),
      },
    },
    {
      name: "ReportLink",
      label: "Report Link",
      options: {
        display: true,
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "500px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let Year = tableMeta.rowData[0];

          return (
            <>
              <a
                className="ReportLink"
                onClick={() => {
                  UploadExcel ? openModal(Year) : openUnitCodeModal(Year);
                }}
                style={{ cursor: "pointer" }}
              >
                {value}
              </a>
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end">
              <div className="col-lg-7 col-md-8 SearchBoxLocation pr-0">
                <div className="row d-flex ser_flx justify-content-end">
                  <div
                    className="float-right d-flex col-lg-5 col-md-6 justify-content-end pr-2 btns_mob"
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <ul
                      className="float-right filter-icon  "
                      style={{ position: "relative" }}
                    >
                      <li
                        onClick={() =>
                          setDashboardFilterOn((current) => !current)
                        }
                        className="filter-btn"
                      >
                        <a className="filter-btn">
                          <i className="fa fa-filter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="clearfix"></div>
        <Collapse in={dashboardFilterOn}>
          <div className="filter-content pt-2 ">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-xs-12 mb-3">
                <div className="form-group">
                  <label className="col-form-label">Financial Year</label>
                  <SelectForm
                    options={financialYearOptions}
                    placeholder="Select Financial Year"
                    isDisabled={false}
                    value={financialYear}
                    onChange={(event: any) =>
                      selectOnChange(event, "FinancialYear")
                    }
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-lg-12 col-md-12"
                style={{ marginBottom: "25px" }}
              >
                <div className="float-right">
                  <button
                    className="btn btn-cancel"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => resetFunction()}
                  >
                    <i className="fas fa-undo"></i> Reset
                  </button>
                  <button
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Apply")}
                  >
                    <i className="fas fa-check"></i> Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>

        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />

        <div className="ModalSize">
          <Modal
            ariaHideApp={false}
            isOpen={OpenUniCodeModal}
            onRequestClose={closeUniCodeModal}
            contentLabel="Unit Codes"
            style={{
              content: {
                width: "30%", // Adjust this value as needed
                height: "14em", // Adjust this value as needed
                margin: "auto", // Center the modal horizontally
                backgroundColor: "#ffffff",
              },
            }}
          >
            <div className="col-lg-12 p-0">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="form-group">
                    <label className="col-form-label">Unit Code</label>
                    {/* <SelectForm
                      options={unitCodeOptions}
                      placeholder="Select Unit Code"
                      isDisabled={false}
                      value={unitcode}
                      onChange={(event: any) =>
                        selectOnChange(event, "UnitCode")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    /> */}
                    <MultiSelect
                      className="unitcodeSelect"
                      key="example_id"
                      options={unitCodeOptions}
                      onChange={(selectedOptions) =>
                        selectOnChange(selectedOptions, "UnitCode")
                      }
                      value={unitcode}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                      style={{ zIndex: "99999" }}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["unitcode_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    className="btn btn-submit"
                    style={{ marginRight: "10px" }}
                    onClick={exportToExcelFunction}
                  >
                    <i className="fas fa-paper-plane"></i> Submit
                  </button>
                  <button
                    className="btn btn-cancel"
                    onClick={closeUniCodeModal}
                  >
                    <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
        {UploadExcel && <ExcelImport />}
      </div>
    </>
  );
};

const DividendWarrantPrintReport = () => {
  return (
    <>
      <YearlyCommonDashboard
        PageName="DividendWarrantPrint"
        ExportToExcelUrl={InsertYearlyWarrentReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default DividendWarrantPrintReport;
